__turbopack_export_value__({
  "actions": "navigation-module__zv5GRq__actions",
  "activeBadge": "navigation-module__zv5GRq__activeBadge",
  "activeBadgeDot": "navigation-module__zv5GRq__activeBadgeDot",
  "brand": "navigation-module__zv5GRq__brand",
  "brandLabel": "navigation-module__zv5GRq__brandLabel",
  "closeButton": "navigation-module__zv5GRq__closeButton",
  "ctaLink": "navigation-module__zv5GRq__ctaLink",
  "eyebrow": "navigation-module__zv5GRq__eyebrow",
  "footer": "navigation-module__zv5GRq__footer",
  "header": "navigation-module__zv5GRq__header",
  "inner": "navigation-module__zv5GRq__inner",
  "localeLink": "navigation-module__zv5GRq__localeLink",
  "localeLinkActive": "navigation-module__zv5GRq__localeLinkActive",
  "localeSwitcher": "navigation-module__zv5GRq__localeSwitcher",
  "menu": "navigation-module__zv5GRq__menu",
  "navItem": "navigation-module__zv5GRq__navItem",
  "navItemActive": "navigation-module__zv5GRq__navItemActive",
  "overlay": "navigation-module__zv5GRq__overlay",
  "panel": "navigation-module__zv5GRq__panel",
  "panelInner": "navigation-module__zv5GRq__panelInner",
  "panelTop": "navigation-module__zv5GRq__panelTop",
  "toggle": "navigation-module__zv5GRq__toggle",
  "toggleIcon": "navigation-module__zv5GRq__toggleIcon",
  "toggleLabel": "navigation-module__zv5GRq__toggleLabel",
  "toggleLine": "navigation-module__zv5GRq__toggleLine",
  "toggleLineBottom": "navigation-module__zv5GRq__toggleLineBottom",
  "toggleLineTop": "navigation-module__zv5GRq__toggleLineTop",
  "toggleOpen": "navigation-module__zv5GRq__toggleOpen",
  "transparent": "navigation-module__zv5GRq__transparent",
});
